module.exports = __webpack_public_path__ + "img/exclamation-square-fill.e4e37764.svg";